import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import Shop from "../../models/shop.model";
import { Customer } from "../../models/customer.model";
import { DialogDeptCustomerComponent } from "../dialog-dept-customer/dialog-dept-customer.component";
import { DialogCustomerComponent } from "../dialog-customer/dialog-customer.component";
import { Person } from "../../models/person.model";
import { Catalog } from "../../models/product.model";

@Component({
  selector: "ngx-view-table-customers",
  styleUrls: ["./view-table-customers.component.scss"],
  templateUrl: "./view-table-customers.component.html",
})
export class ViewTableCustomersComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Input() mode?: string = ""; //dept / categories
  @Input() source: LocalDataSource = new LocalDataSource();
  @Input() users?: Person[];
  @Input() customers?: Customer[] = [];
  @Input() productCategories?: Catalog[];

  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();
  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  uid = "anonymous";
  user: User;

  //ng2-smart-table config
  settings = {};

  constructor(
    private userService: UserService,
    private dialogService: NbDialogService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          const mode = this.mode;
          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              fullName: {
                title: "Khách hàng",
                type: "text",
              },
              mobile: {
                title: "Điện thoại",
                type: "text",
              },
              email: {
                title: "Email",
                type: "text",
              },
              saleAmount: {
                title: "Doanh thu",
                width: "100px",
                filter: false,
                type: "custom",
                hide: mode === "dept" ? false : true,
                renderComponent: StbCustomRenderNumberComponent,
              },
              paidAmount: {
                title: "Thanh toán",
                width: "100px",
                filter: false,
                type: "custom",
                hide: mode === "dept" ? false : true,
                renderComponent: StbCustomRenderNumberComponent,
              },
              debitAmount: {
                title: "Còn nợ",
                width: "100px",
                filter: false,
                type: "custom",
                hide: true,
                renderComponent: StbCustomRenderNumberComponent,
              },
              assignName: {
                title: "TK Quản lý",
                type: "text",
                hide: true,
              },
            },
          };

          if (this.mode === "categories") {
            console.log("settings:", this.settings["columns"]["assignName"]);

            delete this.settings["columns"]["saleAmount"];
            delete this.settings["columns"]["paidAmount"];
            delete this.settings["columns"]["debitAmount"];
          } else {
            delete this.settings["columns"]["assignName"];
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);

    let itemMore = _.clone(item);

    if (this.mode == "dept") {
      this.dialogService
        .open(DialogDeptCustomerComponent, {
          context: {
            shopId: this.shopId,
            uid: this.uid,
            user: this.user,
            shop: this.shop,
            customer: itemMore,
          },
          closeOnBackdropClick: false,
        })
        .onClose.subscribe((value: Customer) => {
          if (value) {
            if (
              item.saleQuantity != value.saleQuantity ||
              item.saleAmount != value.saleAmount ||
              item.paidAmount != value.paidAmount ||
              item.debitAmount != value.debitAmount ||
              item.profitAmount != value.profitAmount
            ) {
              item.saleQuantity = value.saleQuantity;
              item.saleAmount = value.saleAmount;
              item.paidAmount = value.paidAmount;
              item.debitAmount = value.debitAmount;
              item.profitAmount = value.profitAmount;

              _.forEach(this.customers, (cus) => {
                if (cus.id === value.id) {
                  cus.saleAmount = value.saleAmount;
                  cus.paidAmount = value.paidAmount;
                  cus.debitAmount = value.debitAmount;
                  cus.isSynced = true;
                  this.onChangeData.emit(true);
                }
              });

              console.log("DialogDeptCustomerComponent/onClose/value:", value);
              this.source.load(this.customers);
            }
          }
        });
    } else {
      this.dialogService
        .open(DialogCustomerComponent, {
          context: {
            header: "Cập nhật khách hàng",
            mode: "edit",
            shopId: this.shopId,
            user: this.user,
            customer: itemMore,
            users: this.users,
            productCategories: this.productCategories,
          },
          closeOnBackdropClick: false,
        })
        .onClose.subscribe((value) => {
          if (value) {
          }
        });
    }
  }
}
